import { render, staticRenderFns } from "./FontSizeSelector.vue?vue&type=template&id=29461a8b"
import script from "./FontSizeSelector.vue?vue&type=script&lang=js"
export * from "./FontSizeSelector.vue?vue&type=script&lang=js"
import style0 from "./FontSizeSelector.vue?vue&type=style&index=0&id=29461a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports